import { render, staticRenderFns } from "./details-modal.component.vue?vue&type=template&id=db83d558&scoped=true"
import script from "./details-modal.component.vue?vue&type=script&lang=js"
export * from "./details-modal.component.vue?vue&type=script&lang=js"
import style0 from "./details-modal.component.vue?vue&type=style&index=0&id=db83d558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db83d558",
  null
  
)

export default component.exports